import { Tabs as AntdTabs } from "antd";
import type { TabsProps as AntdTabsProps } from "antd";

interface TabItem {
  key: string;
  label: React.ReactNode;
  children: React.ReactNode;
  count?: number; // optioneel rood cirkeltje
}

export interface TabsProps extends Omit<AntdTabsProps, "items"> {
  items: TabItem[];
}

export const Tabs = ({
  type = "card",
  indicator = { size: 0 },
  items,
  ...props
}: TabsProps) => {
  const mappedItems = items.map((item) => ({
    ...item,
    label: (
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        {item.label}
        {item.count && item.count > 0 && (
          <span
            style={{
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
              width: 22,
              height: 22,
              borderRadius: "50%",
              backgroundColor: "#d6484d",
              color: "#fff",
              fontSize: 13,
              fontWeight: 600,
              marginRight: "-8px",
            }}
          >
            {item.count}
          </span>
        )}
      </div>
    ),
  }));

  return (
    <AntdTabs
      type={type}
      indicator={indicator}
      classNames={{
        item: "!border-[#e9e9e9]",
        ...props?.classNames,
      }}
      styles={{
        header: {
          "--ant-color-border-secondary": "transparent",
        },
        item: {
          borderRadius: "20px",
          fontWeight: 600,
        },
        ...props?.styles,
      }}
      {...props}
      items={mappedItems}
    />
  );
};
